import React from 'react'
import PropTypes from 'prop-types'
import upperCase from 'lodash/upperCase'
import {useTranslation} from 'react-i18next'

const statusValues = {
  completed: 'green',
  incomplete: 'green',
  open: 'blue',
}

function Header({data, isTemplate}) {
  const {t} = useTranslation()

  return (
    <div className="audit-expand__header">
      {data.name.toUpperCase()}
      <span
        className={
          'audit-expand__status' +
          `${(statusValues[data.status] && ` audit--${statusValues[data.status]}`) || ''}`
        }
      >
        {!isTemplate &&
          ((statusValues[data.status] && upperCase(t(`audit.table.status.${data.status}`))) ||
            upperCase(t(`audit.table.status.scheduled`)))}
      </span>
    </div>
  )
}

Header.propTypes = {
  data: PropTypes.shape({}).isRequired,
}

Header.displayName = 'Header'

export default Header
